<template>
  <div class="user-management_inviting-modal">
    <HKLModal
      ref="modal"
      :title="$t('hint.inviteAllUsers')"
      okBtnAction="yesInvite"
      @onOkClick="saveAndSendInviteEmails"
    >
      <div class="invite-user__slot">
        <div
          v-if="shouldShowSubAccounts"
          class="invite-users__body"
        >
          <div class="invite-users__title">
            {{ $t('tenancy.tenancyUserWithS') }}
          </div>
          <ul class="invite-users__list">
            <li
              v-for="item in needInvitedSubAccounts"
              :key="item.id"
            >
              {{ item.username }}
            </li>
          </ul>
        </div>
        <br>
        <div
          v-if="shouldShowContractors"
          class="invite-users__body"
        >
          <div class="invite-users__title">
            {{ $t('tenancy.sawpContractorWithS') }}
          </div>
          <ul class="invite-users__list">
            <li
              v-for="item in needInvitedStandaloneContractors"
              :key="item.id"
            >
              {{ item.userAccount }}
            </li>
          </ul>
        </div>
      </div>
    </HKLModal>
  </div>
</template>

<script>
import { unref, computed } from 'vue-demi'
import HKLModal from '@/controls/Modal/HKLModal.vue'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { useRouteParamId } from '@/router/useRouter'
import { useStoreActions, useStoreGetters } from '@/store'
import { useNeedInvitedStandaloneContractors, useNeedInvitedSubAccounts, useHasTenantSwpRight } from './tenancy.hook'
import { activateSawpContractorAndSendEmail, activateSubAccountAndSendEmail } from './tenancy.utils'

/**
 * @type {import('vue').Component}
 */
export default {
  components: {
    HKLModal,
  },
  setup () {
    const tenancyId = useRouteParamId()
    const { accounts, isMaster: isTenantMaster, isSubAdmin: isTenantSubAdmin } = useStoreGetters('ccd', ['accounts', 'isMaster', 'isSubAdmin'])
    const { sawpContractors } = useStoreGetters('tenancyContractors', ['validationResult', 'sawpContractors'])
    const { loadTenancy } = useStoreActions('ccd', ['loadTenancy'])
    const modalRef = useRefModal()
    const needInvitedStandaloneContractors = useNeedInvitedStandaloneContractors(sawpContractors)
    const needInvitedSubAccounts = useNeedInvitedSubAccounts(accounts)
    const hasSWPRight = useHasTenantSwpRight()
    const hasAdminEntitlement = computed(() => unref(isTenantMaster) || unref(isTenantSubAdmin))
    const shouldShowSubAccounts = computed(() => {
      return unref(hasAdminEntitlement) && unref(needInvitedSubAccounts).length
    })
    const shouldShowContractors = computed(() => {
      return unref(hasSWPRight) && unref(needInvitedStandaloneContractors).length
    })
    return {
      ...modalRef,
      open: () => {
        if (unref(shouldShowSubAccounts) || unref(shouldShowContractors)) {
          modalRef.open()
        }
      },
      shouldShowSubAccounts,
      shouldShowContractors,
      needInvitedStandaloneContractors,
      needInvitedSubAccounts,
      saveAndSendInviteEmails: async () => {
        if (unref(hasAdminEntitlement)) {
          await Promise.all(unref(needInvitedSubAccounts).map(async item => {
            await activateSubAccountAndSendEmail(unref(tenancyId), item)
          }))
        }
        if (unref(hasSWPRight)) {
          await Promise.all(unref(needInvitedStandaloneContractors).map(async item => {
            await activateSawpContractorAndSendEmail(unref(tenancyId), item)
          }))
        }
        await loadTenancy(unref(tenancyId))
      },
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
